import disappointedIcon from "../assets/illustrations/guide/emotional-awareness/emotions/disappointed.svg";
import hurtIcon from "../assets/illustrations/guide/emotional-awareness/emotions/hurt.svg";
import embarrassedIcon from "../assets/illustrations/guide/emotional-awareness/emotions/embarrassed.svg";
import anxiousIcon from "../assets/illustrations/guide/emotional-awareness/emotions/anxious.svg";
import lonelyIcon from "../assets/illustrations/guide/emotional-awareness/emotions/lonely.svg";
import jealousIcon from "../assets/illustrations/guide/emotional-awareness/emotions/jealous.svg";
import guiltyIcon from "../assets/illustrations/guide/emotional-awareness/emotions/guilty.svg";
import ashamedIcon from "../assets/illustrations/guide/emotional-awareness/emotions/ashamed.svg";
import frustratedIcon from "../assets/illustrations/guide/emotional-awareness/emotions/frustrated.svg";
import overwhelmedIcon from "../assets/illustrations/guide/emotional-awareness/emotions/overwhelmed.svg";
import hopefulIcon from "../assets/illustrations/guide/emotional-awareness/emotions/hopeful.svg";
import excitedIcon from "../assets/illustrations/guide/emotional-awareness/emotions/excited.svg";
import gratefulIcon from "../assets/illustrations/guide/emotional-awareness/emotions/grateful.svg";

export const EMOTION_ICONS = {
  disappointed: disappointedIcon,
  hurt: hurtIcon,
  embarrassed: embarrassedIcon,
  anxious: anxiousIcon,
  lonely: lonelyIcon,
  jealous: jealousIcon,
  guilty: guiltyIcon,
  ashamed: ashamedIcon,
  frustrated: frustratedIcon,
  overwhelmed: overwhelmedIcon,
  hopeful: hopefulIcon,
  excited: excitedIcon,
  grateful: gratefulIcon,
};

export function getEmotionIcon(key) {
  return EMOTION_ICONS[key] || null;
}
